module.exports = __webpack_public_path__ + "img/block_4.139b58d7.webp";